import { render, staticRenderFns } from "./FaceRecognitionReportScreen.vue?vue&type=template&id=3d92b736"
import script from "./FaceRecognitionReportScreen.vue?vue&type=script&lang=js"
export * from "./FaceRecognitionReportScreen.vue?vue&type=script&lang=js"
import style0 from "./FaceRecognitionReportScreen.vue?vue&type=style&index=0&id=3d92b736&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports